import React, { useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { CloseIcon, DownloadIcon, ShrinkIcon } from "../../assets/Icons";

const FilePreviewModal = ({ show, handleClose, file }) => {
  const [loading, setLoading] = useState(true);
  if (!file) return null;
  const renderPreview = () => {
    const fileType = file.url.split(".").pop().toLowerCase();
    if (["jpg", "jpeg", "png", "gif", "webp"].includes(fileType)) {
      return (
        <div className="uploadedimage">
          <img
            src={file.url}
            alt={file.name}
            className="img-fluid"
            onLoad={() => setLoading(false)}
            onError={() => setLoading(false)}
          />
        </div>
      );
    }

    if (["mp4", "webm", "ogg"].includes(fileType)) {
      return (
        <video
          controls
          style={{ maxHeight: "75vh", maxWidth: "100%" }}
          onLoadedData={() => setLoading(false)}
          onError={() => setLoading(false)}
        >
          <source src={file.url} type={`video/${fileType}`} />
          Your browser does not support the video tag.
        </video>
      );
    }

    if (fileType === "pdf") {
      return (
        <iframe
          src={file.url}
          title={file.name}
          width="100%"
          height="600px"
          onLoad={() => setLoading(false)}
          onError={() => setLoading(false)}
          style={{ border: "none", display: loading ? "none" : "block", borderRadius: "1rem" }}
        />
      );
    }

    return <p>Preview not available for this file type.</p>;
  };

  const handleDownloadFile = async (file) => {
    let url = file.url;
    try {
      const response = await fetch(url, { mode: 'cors' });
      if (!response.ok) throw new Error('Network response was not ok');
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = downloadUrl;
      a.download = file.name || url.split('/').pop();
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error('Download failed:', error);
    }
  }

  return (
    <Modal
      show={show}
      onHide={() => {
        handleClose();
      }}
      size="xl"
      centered
      backdrop="static"
      keyboard={true}
      className="previewmodal"
    >
      <Modal.Header>
        <Modal.Title>{file.name}</Modal.Title>
        <div className="modalcontrol">
          <span className="downloadbtn cursor-pointer" title="Download File" onClick={() => handleDownloadFile(file)}>
            <DownloadIcon />
          </span>
          <span
            className="closebtn cursor-pointer"
            aria-hidden="true"
            onClick={() => {
              handleClose();
            }}
          >
            <CloseIcon />
          </span>
        </div>
      </Modal.Header>
      <Modal.Body className="text-center">
        {/* {loading && (
          <div className="d-flex flex-column align-items-center justify-content-center mb-3">
            <Spinner animation="border" size="sm" className="me-2" />
            <span>Loading preview...</span>
          </div>
        )} */}
        {renderPreview()}
      </Modal.Body>
    </Modal>
  );
};

export default FilePreviewModal;
